import { useAuthUserStore } from "@/stores/authUser";

export default function unAuthOrRCUser() {
    const authUserStore = useAuthUserStore();
    const u = authUserStore.user;
    if (u && !u.related.rcuser) {
        return {
            name: "library.assigned"
        };
    }
}
